// OAuth2 API interface for consent flow
// You may want to adapt endpoints and types to your backend
import axios from '@/services/axiosApiService';
import { BASE_URL } from '../config';

export interface OAuth2ConsentRequest {
  client_id: string;
  state: string;
  redirect_uri: string;
  response_type: string;
  scope: string;
}

export interface OAuth2ConsentResponse {
  state: string;
  redirect_uri: string;
  code: string;
}

// Submit the user's consent decision (allow)
export async function submitConsentResponse(data: OAuth2ConsentRequest): Promise<OAuth2ConsentResponse> {
  const res = await axios.post(`${BASE_URL}/oauth/authorize/consent`, data);
  return res.data as OAuth2ConsentResponse;
}
